import {WEBSOCKET_SET_CONNECTION_STATE, WEBSOCKET_SET_ERROR_MESSAGE} from './constants';
import {IReduxWebSocketServiceState} from '../../../@interfaces';

export const websocketSetConnectionState = (
    connectionState: IReduxWebSocketServiceState['connectionState'],
    errorMessage: IReduxWebSocketServiceState['errorMessage'] | null = null,
) => ({type: WEBSOCKET_SET_CONNECTION_STATE, payload: {connectionState, errorMessage}});
export const websocketSetErrorMessage = (errorMessage?: string) => ({
    type: WEBSOCKET_SET_ERROR_MESSAGE,
    payload: {errorMessage}
});
export const websocketAddListener = (channel: string) => ({type: WEBSOCKET_SET_ERROR_MESSAGE, payload: {channel}});
export const websocketRemoveListener = (channel: string) => ({type: WEBSOCKET_SET_ERROR_MESSAGE, payload: {channel}});
